import React, { useEffect, useState } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import regVehIcon from "../../../../../assets/design-revamp-company/company-detail-headers/reg-veh-icon.svg";
import { useTranslation } from "react-i18next";
import { getBusinessVehicles } from "../../../../../apis/Business/Business";
import handleToFixedNum from "../../components/HeaderBox/handleToFixedNum";
import formatDate from "../../components/HeaderBox/formatDate";
import regVehGraphic from "../../../../../assets/design-revamp-company/company-detail-headers/reg-veh-graphic-icon.svg";

const RegVehIcon = () => (
  <img src={regVehIcon} alt="Water Icon" width={76} height={76} />
);

const RegVehHeader = ({
  className,
  leftBoxProps,
  rightBoxProps,
  businessId,
  show,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalObjRegVeh, setTotalObjRegVeh] = useState([]);
  const [systemBoundaryRegVeh, setSystemBoundaryRegVeh] = useState("");
  useEffect(() => {
    getBusinessVehicles({
      id: businessId,
      setTotalObj: setTotalObjRegVeh,
      setSystemBoundaryVehicle: setSystemBoundaryRegVeh,
    });
  }, [businessId]);

  return (
    <CategoryComponent
      show={show}
      className={`regveh-category ${className || ""}`}
      leftBoxProps={{
        icon: <RegVehIcon />,
        title: t("REGISTERED_VEHICLES"),
        description: t("REGISTERED_VEHICLES_INTRO"),
        scopes: [{ scope: "Scope 1", filled: true }],
        graphicIcons: [{ icon: regVehGraphic }],
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_CATEGORY"),
            items: [
              {
                subtitle: t("EXPENSES"),
                subitems: [
                  {
                    label: "DKK",
                    value: handleToFixedNum(
                      totalObjRegVeh,
                      totalObjRegVeh?.total_expenses
                    ),
                  },
                ],
              },
              {
                subtitle: `${t("EMISSIONS")} ${handleToFixedNum(
                  totalObjRegVeh,
                  totalObjRegVeh?.total_emissions
                )} (tCO₂e)`,
                subitems: [
                  {
                    value: handleToFixedNum(
                      totalObjRegVeh,
                      totalObjRegVeh.total_scope_1
                    ),
                    scopes: ["Scope 1"],
                  },
                  {
                    value: handleToFixedNum(
                      totalObjRegVeh,
                      totalObjRegVeh.total_scope_2
                    ),
                    scopes: ["Scope 2"],
                  },
                  {
                    value: handleToFixedNum(
                      totalObjRegVeh,
                      totalObjRegVeh.total_scope_3
                    ),
                    scopes: ["S:3, C:8"],
                  },
                  {
                    value: handleToFixedNum(
                      totalObjRegVeh,
                      totalObjRegVeh.total_outside_scope
                    ),
                    scopes: ["Outside"],
                  },
                ],
              },
            ],
          },
        ],
        lastUpdated: totalObjRegVeh?.updated_at
          ? formatDate(totalObjRegVeh?.updated_at)
          : t("DD_MM_YYYY"),
        ...rightBoxProps,
      }}
      systemBoundaryProps={{
        systemBoundary: systemBoundaryRegVeh,
        setSystemBoundary: setSystemBoundaryRegVeh,
        businessId: businessId,
        totalObjCategory: totalObjRegVeh.category_name,
      }}
      {...props}
    />
  );
};

export default RegVehHeader;
